import { Avatar, Divider, Flex, Text } from '@chakra-ui/react'
import { useEffect, useRef, useState } from 'react'
import { AiOutlineTable } from 'react-icons/ai'
import { BiTask } from 'react-icons/bi'
import { BsCalendarCheck } from 'react-icons/bs'
import { FaClipboardList, FaClock, FaComments, FaPeopleArrows, FaStreetView, FaTachometerAlt, FaUserClock } from 'react-icons/fa'
import { FiMenu } from 'react-icons/fi'
import { GoGraph } from 'react-icons/go'
import { TbDoorEnter } from 'react-icons/tb'
import { iItemDashResponse, iModel } from '../..'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { ElementoTooltipCmp } from '../../../../../components/ElementoTooltipCmp'
import { GetNomeItemFeedback } from '../../../../../Utils/Helper'
import { Menu, MenuItem, SidebarContainer } from './styles'

interface iProps {
  itemAtual: string
  itensOpacosIds: string[]
  fase: number
  model: iModel
  isLoading: boolean
  onSelectItem: (itemId: string, fase: number) => void
  onChangeIsExpanded: (val: boolean) => void
}

export const SidebarFeedback: React.FC<iProps> = ({ model, fase, itemAtual, onSelectItem, onChangeIsExpanded, itensOpacosIds, isLoading }) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const [isSticky, setIsSticky] = useState(false)
  const [isExpandedItems, setIsExpandedItems] = useState(true)
  const [HeaderVisiblePx, setHeaderVisiblePx] = useState(0)
  const menuRef = useRef<HTMLUListElement | null>(null)

  const toggleSidebar = (val: boolean): void => {
    onChangeIsExpanded(val)
    setIsExpanded(val)

    if (val) {
      setTimeout(() => {
        setIsExpandedItems(val)
      }, 200)
    } else {
      setIsExpandedItems(val)
    }
  }

  function GetColorByStatus(status: number): string {
    switch (status) {
      case 0:
        return 'var(--Red'

      case 1:
        return 'var(--Yellow'

      case 2:
        return 'var(--Orange'

      default:
        return 'var(--Green2'
    }
  }

  useEffect(() => {
    const handleScroll = (): void => {
      if (menuRef.current) {
        const offsetTop = menuRef.current.getBoundingClientRect().top
        setIsSticky(offsetTop <= 0)

        setHeaderVisiblePx(Math.abs(offsetTop))
      }
    }

    window.addEventListener('scroll', handleScroll)
    handleScroll()

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  function GetIconByTipoItem(tipo: number, size?: number): any {
    switch (tipo) {
      case 0:
      case 3:
      case 4:
        return <FaStreetView size={size} />

      case 2:
        return <FaClock size={size} />

      case 6:
        return <GoGraph size={size} />

      case 5:
      case 10:
        return <FaClipboardList size={size} />

      case 15:
        return <FaComments size={size} />

      case 13:
        return <FaTachometerAlt size={size} />

      case 8:
      case 11:
        return <FaPeopleArrows size={size} />

      case 9:
        return <FaUserClock size={size} />

      case 1:
      case 14:
        return <BsCalendarCheck size={size} />

      case 7:
      case 12:
        return <AiOutlineTable size={size} />
    }

    return <FaPeopleArrows/>
  }

  function GetNome(item: iItemDashResponse): any {
    switch (item.tipo) {
      case 0:
      case 3:
      case 4:
        return <Flex flexDir={'column'}>
          {item.avaliacao?.nomePesquisa}
          <Text fontSize='11px' fontWeight={400}>{GetNomeItemFeedback(item.tipo)}</Text>
        </Flex>

      case 5:
        return <Flex flexDir={'column'}>
        {item.formulario?.nome}
        <Text fontSize='11px' fontWeight={400}>{GetNomeItemFeedback(item.tipo)}</Text>
      </Flex>

      case 11:
        return <Flex flexDir={'column'}>
        {item.realizarReuniaoOne?.configuracao.assunto}
        <Text fontSize='11px' fontWeight={400}>{GetNomeItemFeedback(item.tipo)}</Text>
      </Flex>
    }

    return GetNomeItemFeedback(item.tipo)
  }

  return (
    <SidebarContainer qtdItems={model.entrada.length + model.desenvolvimento.length} isExpanded={isExpanded} onMouseEnter={() => toggleSidebar(true)}>
      <Flex flexDir={'column'} color={'var(--c1)'} display={isExpanded ? 'none' : undefined} pos={'absolute'} fontSize={'24px'} left={'0px'} w={'66px'} top={'30px'} gap={'1.5rem'} justifyContent={'center'} alignItems={'center'}>
        <Avatar src={model.participante.avatar} w={'2.75rem'} h={'2.75rem'}/>
        <Flex borderRadius={'50%'} p={'.5rem'} boxShadow={itemAtual === '' ? '0 0 5px 1px #fff' : undefined}>
          <FaPeopleArrows/>
        </Flex>
        {model.entrada.map(e => {
          return (<>
            <Flex borderRadius={'50%'} p={'.5rem'} boxShadow={itemAtual === e.id ? '0 0 5px 1px #fff' : undefined}>
              {GetIconByTipoItem(e.tipo)}
            </Flex>
          </>)
        })
        }
        {model.desenvolvimento.map((e, i) => {
          return (<>
            <Flex borderRadius={'50%'} p={'.5rem'} boxShadow={itemAtual === e.id ? '0 0 5px 1px #fff' : undefined}>
              {GetIconByTipoItem(e.tipo)}
            </Flex>
          </>)
        })
        }
      </Flex>
      <Menu expanded={isExpanded} ref={menuRef} isSticky={isSticky} topPx={HeaderVisiblePx}>
        <Flex justifyContent={'space-between'} w={'full'} alignItems={'center'} p={isExpanded ? '0 1rem 1rem 1rem' : '0'} borderBottom={'2px solid var(--c4)'}>
          {isExpanded && <Flex justifyContent={'space-between'} gap={'1rem'} alignItems={'center'} w={'100%'}>
            <Flex fontSize={'14px'} fontWeight={'600'} alignItems={'center'} gap={'.5rem'} w={'100%'}>
              <Avatar src={model.participante.avatar} size={'sm'}/>
              {model.participante.nome}
            </Flex>
            <ElementoTooltipCmp label='Minimizar menu lateral' bg={'var(--Red)'}>
              <ButtonCmp OutlineColor={'Red'} small onClick={() => toggleSidebar(false)}><FiMenu/></ButtonCmp>
            </ElementoTooltipCmp>
          </Flex>}
        </Flex>
        <MenuItem isDisabled={isLoading} style={isLoading ? { opacity: '.4', cursor: 'not-allowed' } : undefined} color={GetColorByStatus(3)} onClick={() => onSelectItem('', -1)} isExpanded={isExpanded} isExpandedItems={isExpandedItems} itemAtual={itemAtual === '' && fase === -1}><Flex w={isExpanded ? '1rem' : '0'}><FaPeopleArrows size={20}/></Flex> Dashboard</MenuItem>

        <Divider borderColor={'var(--c6)'} opacity={'.8'} mt={'1rem'}/>

        <Flex fontSize={'16px'} fontWeight={'600'} alignItems={'center'} gap={'.5rem'} px={'1rem'}>
          <TbDoorEnter size={20}/>
          Informações prévias
        </Flex>

        {model.entrada.sort((a, b) => { if (a.ordem && b.ordem) { return a.ordem - b.ordem } else { return 0 } }).map(e => {
          return <MenuItem isDisabled={isLoading || itensOpacosIds.includes(e.id)} style={(isLoading || itensOpacosIds.includes(e.id)) ? { opacity: '.4', cursor: 'not-allowed' } : undefined} color={itensOpacosIds.includes(e.id) ? 'var(--c6)' : GetColorByStatus(e.status)} onClick={() => { if (!itensOpacosIds.includes(e.id)) { onSelectItem(e.id, 0) } }} isExpanded={isExpanded} isExpandedItems={isExpandedItems} itemAtual={itemAtual === e.id && fase === 0}><Flex w={isExpanded ? '1rem' : '0'}>{GetIconByTipoItem(e.tipo, 20)}</Flex> {GetNome(e)}</MenuItem>
        })}

        <Divider borderColor={'var(--c6)'} opacity={'.8'} mt={'1rem'}/>

        <Flex fontSize={'16px'} fontWeight={'600'} alignItems={'center'} gap={'.5rem'} px={'1rem'}>
          <BiTask size={20}/>
          Itens para condução
        </Flex>

        {model.desenvolvimento.sort((a, b) => { if (a.ordem && b.ordem) { return a.ordem - b.ordem } else { return 0 } }).map(e => {
          return <MenuItem isDisabled={isLoading} style={isLoading ? { opacity: '.4', cursor: 'not-allowed' } : undefined} color={GetColorByStatus(e.status)} onClick={() => onSelectItem(e.id, 1)} isExpanded={isExpanded} isExpandedItems={isExpandedItems} itemAtual={itemAtual === e.id && fase === 1}><Flex w={isExpanded ? '1rem' : '0'}>{GetIconByTipoItem(e.tipo, 20)}</Flex> {GetNome(e)}</MenuItem>
        })}
      </Menu>
    </SidebarContainer>
  )
}
